import { Icon, LabelButton, ModalContainer } from '@teamsnap/snap-ui';
import {
  AMPLITUDE_PRE_CONFIRMATION_ACTION,
  useAmplitude,
} from 'hooks/amplitude';
import { usePostRegEditDrawer } from 'hooks/postRegEditDrawer';
import * as React from 'react';
import { FormResult } from '../types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  formResult?: FormResult;
}

export function EditConfirmationModal({ formResult, onClose, isOpen }: Props) {
  const { amplitudeTrack } = useAmplitude();
  const { confirmation } = usePostRegEditDrawer();
  if (!formResult || !confirmation) {
    return null;
  }
  const { order } = confirmation;
  const viewOrderLink = order
    ? `/organizations/${order.scopeId}/financials/order/${order.orderNumber}/details`
    : '';
  return (
    <ModalContainer
      data-testid="EditConfirmationModal--container"
      isOpen={isOpen}
      className="sui-p-5 sui-w-auto"
      style={{ minWidth: '25rem' }}
      onClose={onClose}
      disableOverlayClose
    >
      <div data-testid="EditConfirmationModal--content">
        <div className="sui-flex sui-mb-4 sui-gap-2 sui-items-center">
          <Icon
            className="sui-text-green-40"
            filled
            size="xl"
            name="check_circle"
          />
          <h2
            data-testid="EditConfirmationModal--heading"
            className="sui-heading-md"
          >
            Updates saved.
          </h2>
        </div>
        <div
          data-testid="EditConfirmationModal--body"
          className="sui-body sui-flex sui-mb-4 sui-pl-1"
        >
          <ul
            className="sui-list-inside"
            data-testid="EditConfirmationModal--updates"
          >
            <li>
              Registration {confirmation.orderUpdated && '& order '}updated
            </li>
            {confirmation?.installmentsUpdated && (
              <li>Payment schedule updated</li>
            )}
            {confirmation?.additionalQuestionsUpdated && (
              <li>Roster profile updated</li>
            )}
            {confirmation?.participantGroupUpdated && (
              <li>Team assignment has not changed</li>
            )}
          </ul>
        </div>
        <div
          data-testid="EditConfirmationModal-footer"
          className="sui-flex sui-justify-end sui-gap-2"
        >
          <LabelButton
            labelText="View order"
            variantType="secondary"
            data-testid="EditConfirmationModal--view-order"
            onClick={() => {
              amplitudeTrack.preConfimation(
                AMPLITUDE_PRE_CONFIRMATION_ACTION.VIEW_ORDER
              );
              window.open(viewOrderLink, '_blank');
            }}
          />
          <LabelButton
            labelText="Close"
            data-testid="EditConfirmationModal--close"
            variantType="primary"
            onClick={() => {
              amplitudeTrack.preConfimation(
                AMPLITUDE_PRE_CONFIRMATION_ACTION.CLOSE
              );
              onClose();
            }}
          />
        </div>
      </div>
    </ModalContainer>
  );
}
